<!--begin::App-->
<div id="kt_app_root" class="d-flex flex-column flex-root app-root">
	<div class="app-page flex-column flex-column-fluid" id="kt_app_page">
		<ng-container *ngIf="appHeaderDisplay">
			<app-header
				[ngClass]="appHeaderDefaultClass"
				id="kt_app_header"
				class="app-header"
				data-kt-sticky="true"
				data-kt-sticky-activate="{default: true, lg: true}"
				data-kt-sticky-name="app-header-minimize"
				data-kt-sticky-offset="{default: '200px', lg: '0'}"
				data-kt-sticky-animation="false"
			></app-header>
		</ng-container>

		<div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
			<ng-container *ngIf="appSidebarDisplay">
				<app-sidebar #ktSidebar id="kt_app_sidebar" class="app-sidebar flex-column" [ngClass]="appSidebarDefaultClass"></app-sidebar>
			</ng-container>

			<ng-container *ngIf="appSidebarPanelDisplay"></ng-container>

			<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
				<div class="d-flex flex-column flex-column-fluid">
					<app-content
						id=" kt_app_content"
						class="app-content"
						[ngClass]="contentCSSClasses"
						[contentContainerCSSClass]="contentContainerCSSClass"
						[appContentContiner]="appContentContiner"
						[appContentContainerClass]="appContentContainerClass"
					></app-content>
				</div>
			</div>
		</div>
	</div>
</div>

<app-scripts-init></app-scripts-init>
<ng-container></ng-container>
<app-invite-user-drawer></app-invite-user-drawer>
<app-create-company-roles-drawer></app-create-company-roles-drawer>
<app-create-pwa-drawer></app-create-pwa-drawer>
<app-select-files-drawer></app-select-files-drawer>
<app-create-loading-files-drawer></app-create-loading-files-drawer>